import { types } from "mobx-state-tree"

const User = types.model('User', {
    can_configure_events: types.boolean,
}).views(self => ({

}))

export default User
